import { SourcingExternalStoreValues } from 'modules/sourcing-external/stores/types';

export const initialSourcingExternalStoreValues: SourcingExternalStoreValues = {
  candidateBatch: null,
  step: 'GENERATING_SEARCH',
  searchQueryInput: null,
  selectedRows: [],
  alreadyInvitedRows: [],
  pendingSelections: new Set(),
  // Campaign setup
  applicationFormData: null,
  channelFormData: null,
  jobInformationFormData: null,
  // Custom message
  isDefaultStartingTemplatedMessageLoading: false,
  defaultStartingTemplatedMessage: null,
  selectedCustomizeCandidateId: null,
  editedOpeningMessage: null,
  customizeMessageFormData: null
};
